import { SearchPriorityEnum } from "Enums";
import { TSavedQueryDTO, TSavedQueryTempDTO } from "Types";

export class SavedQueryLogic {

    public determineMainActionObject(query: TSavedQueryDTO | TSavedQueryTempDTO): string[] {
        if(query.actionObjects.length === 0) return [];

        for (const actionObject of query.actionObjects) {
            if(actionObject.searchPriority === SearchPriorityEnum.Must) {
                return [actionObject.action, actionObject.dobject];
            }
        }

        for (const actionObject of query.actionObjects) {
            if(actionObject.searchPriority === SearchPriorityEnum.Should) {
                return [actionObject.action, actionObject.dobject];
            }
        }

        return [];
    }
}

export const SavedQueryLogicSingleton = new SavedQueryLogic();